export enum $jobIndustry {
  _id = '_id',
  name = 'name',
  description = 'description',
  translationKey = 'translationKey',
}
